import dayjs from 'dayjs';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Tooltip from '@mui/material/Tooltip';
import { Box, Typography } from '@mui/material';
import en from './intl/en.json';
import de from './intl/de.json';
import jp from './intl/jp.json';
import vn from './intl/vn.json';
import th from './intl/th.json';
import fr from './intl/fr.json';
// front end version


/**
 * 3.5 contains the content planner
 */
export const VERSION = "4.0.1";

////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

export const ON_PREMISE_VERSION = false;

export const SERVER_ADDRESS = ON_PREMISE_VERSION
  ? "/backend3-1"
  : "elevatortvbackend.appspot.com";

//export const SERVER_ADDRESS = "/backend3-1";
//this one only for development
//export const SERVER_ADDRESS = "http://192.168.1.3/backend3-1";

export const WHATSAPP_BIZ_NR = "6598307109";


////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

const TRANSLATIONS = { en, de, jp, vn, th, fr };
let activeLanguage = 'en';

export function setTranslationLanguage(language) {
  const normalized = String(language || 'en').toLowerCase().split(/[-_]/)[0];
  activeLanguage = TRANSLATIONS[normalized] ? normalized : 'en';
}

export function trans(msgID) {
  let rawID = msgID;
  if (rawID && typeof rawID === 'object') {
    rawID = rawID.id ?? rawID.message ?? rawID.reason;
    if (rawID === undefined) {
      try {
        rawID = JSON.stringify(msgID);
      } catch (_error) {
        rawID = 'unknown_message';
      }
    }
  }
  const id = String(rawID ?? '');
  const localized = TRANSLATIONS[activeLanguage]?.[id];
  if (typeof localized === 'string') return localized;
  const fallback = TRANSLATIONS.en[id];
  return typeof fallback === 'string' ? fallback : `[${id}]`;
}

export function getServerBase() {
    if(ON_PREMISE_VERSION) {
      //return "http://"+SERVER_ADDRESS;
      return SERVER_ADDRESS; //"/backend3-1"; // this will be like /te
    }else{
      return "https://"+SERVER_ADDRESS;
    }
}

export const EMAIL_REGEX =  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
export function isEmail( emailAddr) {
  return EMAIL_REGEX.test(emailAddr);
}

export const PHONE_REGEX =  /^\+\s*[0-9\s*]{7,}$/;
export function isPhone( phone) {
  // remarks: ^abc$ --> means exact match
  // "/" start and "/" end tags
  // \s* as many whitespace as wishes
  // {7,} at least 7 numbers
  // \+ must start with +
  return PHONE_REGEX.test(phone);
}

export function compareDevice( a, b) {
  //console.log("localcompare "+a.device_name);
  //console.log("localcompare "+b.device_name);
  return a.device_name.localeCompare(b.device_name);
}

export function compareGroup( a, b) {
  return a.group_name.localeCompare(b.group_name);
}

export function filterOutEmptyGroups( groups) {
  var res = [];
  for(var i=0; i<groups.length; i++) {
      if(groups[i].device_ids.length>0) res.push(groups[i]);
  }
  return res;
}

export function sendCMDToServer(url) {
  var accessToken = localStorage.getItem("etv.access_token");
  var reqUserID = localStorage.getItem("etv.user_id");
  fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
    .then(res => res.json())
    .then(
      (result) => {
        if(result["result"]) {
          //console.log("ok");
        }else{
          console.log("result not ok="+JSON.stringify(result));
        }
      },
      (error) => {
        console.log("error="+error);
      }
    )
}


export async function sendCMDToServerAwait(url, options = {}) {
  const accessToken = localStorage.getItem("etv.access_token");
  const reqUserID = localStorage.getItem("etv.user_id");

  const finalOptions = {
    method: "GET",
    headers: {
      user_id: reqUserID,
      access_token: accessToken,
      ...(options.headers || {}),
    },
    cache: "no-store",
    ...options,
  };

  const res = await fetch(url, finalOptions);

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `HTTP ${res.status}`);
  }

  try {
    return await res.json();
  } catch {
    return await res.text();
  }
}




export function sendCMDToServerListener(url, resultListener) {
  var accessToken = localStorage.getItem("etv.access_token");
  var reqUserID = localStorage.getItem("etv.user_id");
  fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
    .then(res => res.json())
    .then(
      (result) => {
        resultListener(result);
      },
      (error) => {
        console.log("error="+error);
      }
    )
}

function getTimeAgoVal( mins) {
  var val = mins;
  if(val<60) return Math.round(val)+" minutes ago";
  val = val/60;
  if(val<24) return Math.round(val)+" hours ago";
  val = val/24;
  if(val<31) return Math.round(val)+" days ago";
  val = val/31;
  if(val<12) return Math.round(val)+" months ago";
  val = Math.round(val/12);
  if(val===1) {
    return Math.round(val)+" year ago";
  }else{
    return Math.round(val)+" years ago";
  }
}

export function getLastConnectInfo(time) {
  var d = new Date(time.replace(/-/g, "/"));
  var diffMins = getLastConnectMins(time);
  var msg = d.toLocaleString();
  if(diffMins<10) {
      return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#67f00c' }}  /></Tooltip>

  }else if(diffMins<60) {
      //less than 1 hour
      return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#f5d247' }}  /></Tooltip>

  }else if(diffMins<1440) {
      //less than 1 day
      return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#f59e07' }}  /></Tooltip>

  }else if(diffMins<10080) {
        //less than 1 week
        return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#f56c11' }}  /></Tooltip>

  }else{
     //less than 1 week
     return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#96080c' }}  /></Tooltip>
  }
}

export function getLastConnectSymbol(time, startup, status) {

  var d = new Date(time.replace(/-/g, "/"));
  var diffMins = getLastConnectMins(time);
  var msg = d.toLocaleString();
  if(startup && startup.trim().length>0) {
    var startupDt = new Date(startup);
    msg = getTimeAgoVal(diffMins)+" (login: "+startupDt.toLocaleString()+")";
  }
  if(status==="offline") {
    return <Tooltip title={"(offline) "+msg} ><FiberManualRecordIcon size='large' style={{ color: '#fa2d33' }}  /></Tooltip>
  }
  //console.log("diffMins="+diffMins);
  if(diffMins<10) {
      return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#67f00c' }}  /></Tooltip>

  }else if(diffMins<60) {
      //less than 1 hour
      return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#f5d247' }}  /></Tooltip>

  }else if(diffMins<1440) {
      //less than 1 day
      return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#f59e07' }}  /></Tooltip>

  }else if(diffMins<10080) {
        //less than 1 week
        return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#f56c11' }}  /></Tooltip>

  }else{
     //less than 1 week
     return <Tooltip title={msg} ><FiberManualRecordIcon size='large' style={{ color: '#96080c' }}  /></Tooltip>
  }
}

export function getLastConnectMins( time) {
  // careful on IOS! --> use ".replace(..)"
  var d = new Date(time.replace(/-/g, "/"));
  var dNow = Date.now();
  var diffMins = (dNow - d)/60000;
  return diffMins;
}

////////////////////////////////////////////////////////////////////////////////

export function makeLayoutURLRelative(url) {
  if(url.indexOf("/contents")>0) {
    // it is a custom layout (stored in the individual's user directory)
    return makeContentURLRelative(url);
  }
  return url.substring(url.indexOf("/layouts"))
}

export function makeContentURLRelative(url) {
  return url.substring(url.indexOf("/contents"))
}

export function isAlphaNumeric( val) {
  return val.match(/^\w+$/) || val.length===0
}


////////////////////////////////////////////////////////////////////////////////


export function createTimeHoursMin(hours, minutes) {
    // Get the current day using dayjs()
    const now = dayjs();
    // Set the hours and minutes to the given values
    const updatedTime = now.hour(hours).minute(minutes).second(0); // Optionally reset seconds to 0
    // Return the updated Day.js object
    return updatedTime;
}

export function createDateNow() {
    var now = dayjs();
    return now;
}

export function createDate(etvDate) {
    const dayjsDate = dayjs(etvDate,'YYYY-MM-DD');
    return dayjsDate;
}

export function createTime(etvTime) {
    const [hours, minutes] = etvTime.split(':').map(Number);
    // Validate that both hours and minutes are numbers
    if (isNaN(hours) || isNaN(minutes)) {
        throw new Error('Invalid time format. Use "HH:mm"');
    }
    const dayjsObject = dayjs().hour(hours).minute(minutes).second(0);
    return dayjsObject;
}

export function createDateYearsPlus(yearsFromNow) {
    // Get the current date
    const now = dayjs();
        // Add one year to the current date
    const yearsLater = now.add(yearsFromNow, 'year');
    // Return the new Day.js object
    return yearsLater;
}

export function oneYearLater() {
    return createDateYearsPlus(1);
}

export function forever() {
  return createDateYearsPlus(30);
}

export function formatDate( date2) {
    if(date2.isValid()) {
        return date2.format('YYYY-MM-DD')
    }
    return null;
}

export function formatTime( date2) {
    if(date2.isValid()) {
        return date2.format('HH:mm');
    }
    return null;
}


export function encodeURIComponentSafe(str) {
  return encodeURIComponent(str)
      //.replace(/'/g, '%27')
      .replace(/'/g, '')
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29')
      .replace(/\*/g, '%2A')
      .replace(/!/g, '%21')
      .replace(/~/g, '%7E');
}


export function PrivacyText() {
  return(
  <Box>
    <Typography variant="h5" gutterBottom>
      Privacy and Data Protection Policy
    </Typography>

    <Typography variant="subtitle1" gutterBottom>
      Effective Date: 1.1.2026
    </Typography>
    <Typography variant="subtitle1" gutterBottom>
      Last Updated: 1.1.2026
    </Typography>

    <Typography variant="body1" paragraph>
      At <b>{getCompany()}</b>, your privacy and data protection are of utmost importance to us. 
      This policy outlines how we collect, use, store, and protect your personal data in accordance with 
      industry standards and applicable laws.
    </Typography>

    <Typography variant="h6" gutterBottom>
      1. Data We Collect
    </Typography>
    <Typography variant="body1" paragraph>
      We may collect the following types of personal information:
    </Typography>
    <Typography component="ul">
      <li>Contact Information: Name, email address, phone number, company details.</li>
      <li>Account Information: Username, password, preferences.</li>
      <li>Transaction Information: Details of purchases or service subscriptions.</li>
      <li>Usage Information: Data related to how you use our website, products, and services.</li>
      <li>Technical Information: IP address, browser type, and device information.</li>
    </Typography>

    <Typography variant="h6" gutterBottom>
      2. How We Use Your Data
    </Typography>
    <Typography variant="body1" paragraph>
      We use your data to:
    </Typography>
    <Typography component="ul">
      <li>Provide and improve our products and services.</li>
      <li>Manage your account and process transactions.</li>
      <li>Communicate with you about updates, promotions, and support.</li>
      <li>Ensure compliance with legal obligations.</li>
      <li>Analyze website usage to enhance user experience.</li>
    </Typography>

    <Typography variant="h6" gutterBottom>
      3. Sharing Your Data
    </Typography>
    <Typography variant="body1" paragraph>
      We do not sell your data. However, we may share it with:
    </Typography>
    <Typography component="ul">
      <li>Service Providers assisting with our services.</li>
      <li>Authorities to comply with legal obligations.</li>
      <li>Third parties, only with your consent.</li>
    </Typography>

    <Typography variant="h6" gutterBottom>
      4. Data Storage and Retention
    </Typography>
    <Typography variant="body1" paragraph>
      Your data is securely stored and retained only as long as necessary to fulfill the outlined purposes or comply with legal requirements.
    </Typography>

    <Typography variant="h6" gutterBottom>
      5. Your Rights
    </Typography>
    <Typography variant="body1" paragraph>
      You have rights to access, correct, delete, or restrict your data. You can also withdraw consent or request a copy of your data.
    </Typography>

    <Typography variant="h6" gutterBottom>
      6. Cookies and Tracking
    </Typography>
    <Typography variant="body1" paragraph>
      We use cookies to enhance your experience. Manage cookies via your browser settings.
    </Typography>

    <Typography variant="h6" gutterBottom>
      7. Security Measures
    </Typography>
    <Typography variant="body1" paragraph>
      We employ encryption, access controls, and regular security assessments to safeguard your data.
    </Typography>

    <Typography variant="h6" gutterBottom>
      8. International Data Transfers
    </Typography>
    <Typography variant="body1" paragraph>
      Your data may be transferred outside your region with safeguards in place to ensure protection.
    </Typography>

    <Typography variant="h6" gutterBottom>
      9. Updates to This Policy
    </Typography>
    <Typography variant="body1" paragraph>
      We may update this policy. Check this page periodically for changes.
    </Typography>

    <Typography variant="h6" gutterBottom>
      10. Contact Us
    </Typography>
    <Typography variant="body1" paragraph>
      For inquiries or concerns, reach us at:
    </Typography>
    <Typography variant="body2">
      <b>{getCompany()}</b>
    </Typography>
    <Typography variant="body2">Email: {getContact()}</Typography>
    <Typography variant="body2">Address: {getAddress()}</Typography>
  </Box>
  )
}

    export const WHITE_LABEL_BRANDS = {
      default: {
        brandName: "elevator.tv", companyName: "elevator.tv GmbH",
        logo: "/image_assets/logo.jpg", contactEmail: "support@elevator.tv",
        address: "Birkenstrasse 47 | CH-6343 Rotkreuz | Switzerland | https://www.elevator.tv",
        country: "Switzerland", loginBackgroundImage: "/image_assets/login-hero-singapore-sunrise.png", favicon: "/favicon.ico",
      },
      "emch.com": {
        brandName: "Emch Aufzüge", companyName: "Emch Aufzüge AG",
        logo: "/image_assets/emch_logo.png", contactEmail: "info@emch.ch",
        address: "Fellerstrasse 23, 3027 Bern, Switzerland",
        country: "Switzerland", loginBackgroundImage: "/image_assets/bern.png", favicon: "/favicon.ico",
      },
      "lift.tv": {
        brandName: "lift.tv", companyName: "elevator.tv GmbH",
        logo: "/image_assets/lifttvlogo.png", contactEmail: "support@elevator.tv",
        address: "Birkenstrasse 47 | CH-6343 Rotkreuz | Switzerland | https://www.lift.tv",
        country: "Switzerland", loginBackgroundImage: "/image_assets/login-hero-singapore-sunrise.png", favicon: "/favicon.ico",
      },
      "nle.jp": {
        brandName: "Nippon Lift Engineering", companyName: "Nippon Lift Engineering",
        logo: "/image_assets/nlelogo.png", contactEmail: "info@nle.jp", address: "https://www.nle.jp",
        country: "Japan", loginBackgroundImage: "/image_assets/tokyo.png", favicon: "/favicon.ico",
      },
      "nle-optilink.jp": {
        brandName: "Optilink", companyName: "Nippon Lift Engineering",
        logo: "/image_assets/nlelogo.png", contactEmail: "info@nle.jp",
        address: "1 Chome-3-1 Shinyokohama, Kohoku Ward, Yokohama, Kanagawa 222-0033, Japan",
        country: "Japan", loginBackgroundImage: "/image_assets/tokyo.png", favicon: "/favicon.ico",
      },
      "lifttech.com.au": {
        brandName: "LiftTech", companyName: "LiftTech",
        logo: "/image_assets/lifttech_logo.jpeg", contactEmail: "customerservice@lifttech.com.au",
        address: "335 Parramatta Road, Leichhardt, NSW 2040, Australia",
        country: "Australia", loginBackgroundImage: "/image_assets/sydney.png", favicon: "/favicon_lifttech.ico",
      },
    };

    export function getBranding() {
      if (ON_PREMISE_VERSION) return {
        ...WHITE_LABEL_BRANDS.default,
        logo: "/image_assets/elevator_onpremise.jpg",
        loginBackgroundImage: "/image_assets/on-premise-city.png",
      };
      const hostname = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
      const domain = Object.keys(WHITE_LABEL_BRANDS)
        .filter((key) => key !== "default")
        .sort((a, b) => b.length - a.length)
        .find((key) => hostname === key || hostname.endsWith(`.${key}`));
      return WHITE_LABEL_BRANDS[domain] || WHITE_LABEL_BRANDS.default;
    }

    export function setFavicon() {
      const domain = window.location.hostname.toLowerCase();
      let iconPath = getBranding().favicon;
      //let iconPath = "/favicon_lifttech.ico";

      if (domain.endsWith("lifttech.com.au")) {
        iconPath = "/favicon_lifttech.ico";
      }

      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = iconPath;
    }

    export function getCompany() {
        return getBranding().companyName;
        /* Legacy domain mapping retained below for reference.
        var domain = window.location.origin;
        if(ON_PREMISE_VERSION) return "elevator.tv GmbH";
        if(!domain || domain.trim().toLowerCase().endsWith('elevator.tv')) return "elevator.tv GmbH";
        if(domain.trim().toLowerCase().endsWith('emch.com')) return "Emch Aufzuege AG";
        if(domain.trim().toLowerCase().endsWith('lift.tv')) return "elevator.tv GmbH";
        if(domain.trim().toLowerCase().endsWith('nle.jp')) return "Nippon Lift Engineering";
        if(domain.trim().toLowerCase().endsWith('lifttech.com.au')) return "LiftTech";
        //default
        return "elevator.tv GmbH"; */
    }

    export function getBrandName() {
        return getBranding().brandName;
    }

    export function getContact() {
        return getBranding().contactEmail;
        /* Legacy domain mapping retained below for reference.
        var domain = window.location.origin;
        if(ON_PREMISE_VERSION) return "support@elevator.tv";
        if(!domain || domain.trim().toLowerCase().endsWith('elevator.tv')) return "support@elevator.tv";
        if(domain.trim().toLowerCase().endsWith('emch.com')) return "info@emch.ch";
        if(domain.trim().toLowerCase().endsWith('lift.tv')) return "support@elevator.tv";
        if(domain.trim().toLowerCase().endsWith('nle.jp')) return "info@nle.jp";
        if(domain.trim().toLowerCase().endsWith('lifttech.com.au')) return "customerservice@lifttech.com.au";
        if(domain.trim().toLowerCase().endsWith('nle-optilink.jp')) return "info@nle.jp";
        //default
        return "support@elevator.tv"; */
    }

    export function getLogo() {
        return getBranding().logo;
        /* Legacy domain mapping retained below for reference.
        var domain = window.location.origin;  
        if(ON_PREMISE_VERSION) return "/image_assets/elevator_onpremise.jpg";
        if(!domain || domain.trim().toLowerCase().endsWith('elevator.tv')) return "/image_assets/logo.jpg";
        if(domain.trim().toLowerCase().endsWith('emch.com')) return "/image_assets/emch_logo.png";
        if(domain.trim().toLowerCase().endsWith('lift.tv')) return "/image_assets/lifttvlogo.png";
        if(domain.trim().toLowerCase().endsWith('nle.jp')) return "/image_assets/nlelogo.png";
        if(domain.trim().toLowerCase().endsWith('lifttech.com.au')) return "/image_assets/lifttech_logo.jpeg";
        if(domain.trim().toLowerCase().endsWith('nle-optilink.jp')) return "/image_assets/optilink.jpg";
        //default
        //return "/image_assets/optilink.jpg";
        return "/image_assets/logo.jpg"; */
    }

    export function getLoginBackgroundImage() {
        return getBranding().loginBackgroundImage;
    }

    export function getAddress() {
        const brand = getBranding();
        return String.fromCharCode(169)+" "+new Date().getFullYear()+" "+brand.companyName+" | "+brand.address;
        /* Legacy domain mapping retained below for reference.
        var domain = window.location.origin;
        if(!domain || domain.trim().toLowerCase().endsWith('elevator.tv')) return String.fromCharCode(169)+" 2026 elevator.tv GmbH | Birkenstrasse 47 | CH-6343 Rotkreuz | Switzerland | https://www.elevator.tv";
        if(domain.trim().toLowerCase().endsWith('emch.com')) return String.fromCharCode(169)+" Emch Aufzüge AG, Fellerstrasse 23, 3027 Bern, Switzerland";
        if(domain.trim().toLowerCase() === 'localhost') return String.fromCharCode(169)+" elevator.tv GmbH 2026 | Birkenstrasse 47 | CH-6343 Rotkreuz | Switzerland ";
        if(domain.trim().toLowerCase().endsWith('lift.tv')) return String.fromCharCode(169)+" lift.tv | elevator.tv GmbH | Birkenstrasse 47 | CH-6343 Rotkreuz | Switzerland | https://www.lift.tv";
        if(domain.trim().toLowerCase().endsWith('nle.jp')) return String.fromCharCode(169)+" Nippon Lifts Engineering | https://www.nle.jp";
        if(domain.trim().toLowerCase().endsWith('lifttech.com.au')) return "LiftTech, 335 Parramatta Road, Leichhardt, NSW 2040.";
        if(domain.trim().toLowerCase().endsWith('nle-optilink.jp')) return "1 Chome-3-1 Shinyokohama, Kohoku Ward, Yokohama, Kanagawa 222-0033, Japan";
        // default
        return "elevator.tv GmbH | Birkenstrasse 47 | CH-6343 Rotkreuz | Switzerland | https://www.elevator.tv"; */
    }

    export function getCountry() {
        return getBranding().country;
        /* Legacy domain mapping retained below for reference.
        var domain = window.location.origin;
        if(!domain || domain.trim().toLowerCase().endsWith('elevator.tv')) return "Switzerland";
        if(domain.trim().toLowerCase().endsWith('emch.com')) return String.fromCharCode(169)+"Switzerland";
        if(domain.trim().toLowerCase() === 'localhost') return String.fromCharCode(169)+"Switzerland ";
        if(domain.trim().toLowerCase().endsWith('lift.tv')) return String.fromCharCode(169)+"Switzerland";
        if(domain.trim().toLowerCase().endsWith('nle.jp')) return String.fromCharCode(169)+"Japan";
        if(domain.trim().toLowerCase().endsWith('lifttech.com.au')) return "Australia";
        if(domain.trim().toLowerCase().endsWith('nle-optilink.jp')) return "Japan";
        // default
        return "Switzerland"; */
    }


export function TermsAndConditions() {
return (
  <Box>
    <Typography variant="h5" gutterBottom>
      Terms and Conditions
    </Typography>

    <Typography variant="subtitle1" gutterBottom>
      Effective Date: 1.1.2025
    </Typography>
    <Typography variant="subtitle1" gutterBottom>
      Last Updated: 1.1.2025
    </Typography>

    <Typography variant="body1" paragraph>
      Welcome to <b>{getCompany()}</b>. These terms and conditions outline the rules and regulations for using our website, products, and services. By accessing or using our services, you agree to comply with these terms.
    </Typography>

    <Typography variant="h6" gutterBottom>
      1. Acceptance of Terms
    </Typography>
    <Typography variant="body1" paragraph>
      By accessing or using our services, you accept and agree to be bound by these terms. If you do not agree with any part of these terms, you must not use our services.
    </Typography>

    <Typography variant="h6" gutterBottom>
      2. Use of Our Services
    </Typography>
    <Typography variant="body1" paragraph>
      You agree to use our services only for lawful purposes and in a way that does not infringe on the rights of others or restrict their use and enjoyment. Prohibited actions include:
    </Typography>
    <Typography component="ul">
      <li>Violating any laws or regulations.</li>
      <li>Uploading or sharing inappropriate multimedia content, including but not limited to explicit, obscene, or offensive material.</li>
      <li>Harming, harassing, or causing distress to others.</li>
      <li>Uploading or distributing malicious software.</li>
      <li>Engaging in unauthorized access or hacking.</li>
    </Typography>

    <Typography variant="h6" style={{marginTop:10}} gutterBottom>
      3. Account Responsibilities
    </Typography>
    <Typography variant="body1" paragraph>
      You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. Notify us immediately of any unauthorized use.
    </Typography>

    <Typography variant="h6" gutterBottom>
      4. Intellectual Property
    </Typography>
    <Typography variant="body1" paragraph>
      All content, trademarks, and materials on our services are the property of <b>{getCompany()}</b>. You may not reproduce, distribute, or use any materials without prior written consent.
    </Typography>

    <Typography variant="h6" gutterBottom>
      5. Payments and Refunds
    </Typography>
    <Typography variant="body1" paragraph>
      All payments for services are final, except as outlined in our refund policy. It is your responsibility to ensure payment details are accurate and up to date.
    </Typography>

    <Typography variant="h6" gutterBottom>
      6. Limitation of Liability
    </Typography>
    <Typography variant="body1" paragraph>
      To the extent permitted by law, <b>{getCompany()}</b> will not be liable for any indirect, incidental, or consequential damages arising from your use of our services.
    </Typography>

    <Typography variant="h6" gutterBottom>
      7. Termination
    </Typography>
    <Typography variant="body1" paragraph>
      We reserve the right to suspend or terminate your access to our services at our sole discretion, without notice, for conduct that violates these terms or is harmful to our interests.
    </Typography>

    <Typography variant="h6" gutterBottom>
      8. Governing Law
    </Typography>
    <Typography variant="body1" paragraph>
      These terms are governed by and construed in accordance with the laws of {getCountry()}. Any disputes will be resolved exclusively in courts of {getCountry()}.
    </Typography>

    <Typography variant="h6" gutterBottom>
      9. Changes to These Terms
    </Typography>
    <Typography variant="body1" paragraph>
      We may update these terms periodically. Continued use of our services indicates acceptance of any changes.
    </Typography>

    <Typography variant="h6" gutterBottom>
      10. Contact Us
    </Typography>
    <Typography variant="body1" paragraph>
      If you have questions or concerns about these terms, please contact us at:
    </Typography>
    <Typography variant="body2">
      <b>{getCompany()}</b>
    </Typography>
    <Typography variant="body2">Email: {getContact()}</Typography>
    <Typography variant="body2">Address: {getAddress()}</Typography>
  </Box>
)
};

